import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { VersaoDebug, VersaoProd, TipoCompilacao, VersaoNum } from "../versao";
import { Http } from "@angular/http";
import { MatDialog } from '@angular/material/dialog';

import { take } from 'rxjs/operators';
import { UsuarioService } from '../services/usuario.service';

import { NgxSpinnerService } from "ngx-spinner";
import { AngularFireAuth } from "@angular/fire/auth";
import { environment } from '../../environments/environment';
import { AlertaVersaoComponentDialog } from '../modules/dialogs/versao-minima-dialog/versao-minima-dialog';
import { AlertaManutencaoDialog } from '../modules/dialogs/manutencao-dialog/manutencao-dialog';
import { ToastrService } from 'ngx-toastr';


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  loginForm: FormGroup;
  submitted: boolean = false;
  bAnonimo: boolean = false;
  bAtualizado: boolean = false;
  versao = VersaoNum;
  auxVersao;

  constructor(
    private usuarioService: UsuarioService,
    private af: AngularFireAuth,
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private spinner: NgxSpinnerService,
    private http: Http,
    private dialog: MatDialog,
    private toastr: ToastrService,
  ) {
    localStorage.removeItem("email");
    localStorage.removeItem("uid");
    localStorage.setItem("tela_atual", "Login");

    if (TipoCompilacao) {
      this.auxVersao = VersaoProd;
    } else {
      this.auxVersao = VersaoDebug;
    }
    this.validarAbaAnonima();
  }

  ngOnInit(): void {

    this.loginForm = this.formBuilder.group({
      // email: [environment.production ? '' : 'wiharlleyteste@gmail.com', [Validators.required, Validators.email]],
      // senha: [environment.production ? '' : 'vendedor123', Validators.required],
      email: [environment.production ? '' : 'matrizipanema2@teste.com.br', [Validators.required, Validators.email]],
      senha: [environment.production ? '' : 'ipanema123', Validators.required],
      remember: [false, null]
    });

    this.usuarioService.getStatusServidor().pipe(take(1)).subscribe(snap => {
      let dados: any = snap.payload.val();

      if (!dados.Status) {
        const dialogRef2 = this.dialog.open(AlertaManutencaoDialog, {
          disableClose: true,
          data: { descricao: dados.Descricao, previsaoRetorno: this.usuarioService.tratarDataHora(dados.TimestampRetorno) },
        });

        dialogRef2.afterClosed().subscribe(result => {
        });

      } else
        if (this.versao < dados.VersaoMinima) {
          const dialogRef = this.dialog.open(AlertaVersaoComponentDialog, { disableClose: true });
          dialogRef.afterClosed().subscribe(result => {
          });
        } else {
          this.bAtualizado = true;
        }
    });
  }

  onSubmit() {
    this.submitted = true;

    // para a função se o formulário não estiver válido
    if (this.loginForm.invalid && !this.bAtualizado) {
      this.logTentativaLogin();
      return;
    }

    this.spinner.show();

    this.af.signInWithEmailAndPassword(this.loginForm.get('email').value, this.loginForm.get('senha').value).then(sign => {
      localStorage.setItem('uid', '' + sign.user.uid);
      localStorage.setItem('login', 'true');


      this.loginForm.get('remember').value ? localStorage.setItem("manter_conectado", "true") : localStorage.setItem("manter_conectado", "false");

      if (sign.user.uid !== environment.idCliente) {
        //Verificar autorização 'e' liberar login;
        this.usuarioService.getFuncionario(sign.user.uid).pipe(take(1)).subscribe(snap => {
          console.log('sign.user.uid', sign.user.uid)
          console.log('snap', snap)
          if (snap) {
            const dados: any = snap;
            if (dados.Status) {
              this.router.navigate(["/pages/dashboard"]);
            } else
              this.toastr.warning('Você não possui permissão para realizar login neste sistema', 'Erro', { progressBar: true, positionClass: 'toast-top-center', });

          } else
            this.toastr.error('Não foi possível verificar seus dados', 'Erro', { progressBar: true, positionClass: 'toast-top-center', });
        });
      } else {
        this.router.navigate(["/pages/dashboard"]);
      }
      this.spinner.hide();

    }).catch(error => {
      this.toastr.error('Usuário ou senha incorretos', 'Erro', { progressBar: true, positionClass: 'toast-top-center', });
      this.logTentativaLogin();
      this.spinner.hide();
    });
  }

  logTentativaLogin() {
    this.http.get('https://jsonip.com').pipe(take(1)).subscribe(async resp => {

      // var auxDate = new Date();
      // var map = {
      //     IP: resp.json().ip,
      //     Email: this.email,
      //     Senha: this.password,
      //     Painel: 'Vendedores',
      //     Timestamp: auxDate.getTime(),
      //     Email_Timestamp: this.email + '_' + auxDate.getTime(),
      //     IP_Timestamp: resp.json().ip + '_' + auxDate.getTime()
      // }
      // this.usuarioService.setLogErroLogin(map);
    });
  }

  redefinirSenha() {
    this.router.navigate(['/recuperar-senha']);
  }

  async validarAbaAnonima() {
    if ('storage' in navigator && 'estimate' in navigator.storage) {
      const { usage, quota } = await navigator.storage.estimate();
      console.log(`Using ${usage} out of ${quota} bytes.`);

      if (quota && quota < 120000000) {
        this.bAnonimo = true;
        alert("Identificamos que você está tentando acessar o painel de uma aba anônima! Não é possível seguir utilizando esse meio de acesso, por favor abra o painel em seu navegador em uma aba não anônima!");
      } else {
        this.bAnonimo = false;
      }
    } else {
      this.bAnonimo = true;
      // alert("Não conseguimos validar o seu navegador, por favor atualize a página e caso necessário, limpe o cache.");
    }
  }

  // convenience getter for easy access to form fields
  get f() { return this.loginForm.controls; }
}
